module.exports = __webpack_public_path__ + "static/media/icon-user.a3fe38e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icon-user.svg
// module id = 795
// module chunks = 0